export default {

  SET_DROPOFFS_REPORTS_REQUESTED(state, dropoffsReportsRequested) {
    state.dropoffsReportsRequested = dropoffsReportsRequested
  },
}